import { z } from "zod";

/**
 * GET/PATCH /profile's `data` (NASAM-247 / NASAM-253). Anything beyond the
 * identity may be null *or absent* -- e.g. a level-0 admin who never changed
 * their password gets no `passwordChangedAt` key at all.
 */
export const profileDtoSchema = z.object({
  id: z.string().min(1),
  username: z.string().min(1),
  email: z.string(),
  nameEn: z.string().nullish(),
  nameAr: z.string().nullish(),
  phoneNumber: z.string().nullish(),
  profilePictureUrl: z.string().nullish(),
  // The client account for its staff, the world itself for the world's own.
  company: z
    .object({
      nameEn: z.string().nullish(),
      nameAr: z.string().nullish(),
    })
    .nullish(),
  enable2FA: z.boolean().optional(),
  passwordChangedAt: z.string().nullish(),
});

export type ProfileDto = z.infer<typeof profileDtoSchema>;

export const profileResponseDtoSchema = z.object({
  message: z.string().optional(),
  data: profileDtoSchema,
});

/**
 * PATCH /auth/change-password's 200. `data` carries the current session's
 * fresh access token; it is missing when every session ended, this one too.
 */
export const changePasswordResponseDtoSchema = z.object({
  message: z.string().optional(),
  data: z.object({ accessToken: z.string().min(1) }).nullish(),
});

/** PATCH /profile's body; only the fields being changed are sent. */
export interface ProfileUpdateDto {
  nameEn?: string;
  nameAr?: string;
  phoneNumber?: string;
  removeProfilePicture?: boolean;
}
